//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from '../../models/common'

import { OpAlarmGroup } from '../../models/core/op-alarm-group'
import { OpAlarmGroupOperator } from '../../models/core/op-alarm-group-operator'
import { OpOperator } from '../../models/core/op-operator'

import { ColumnModel } from '../../modules/api/api.models'

import { LocalizationHelper } from '../../helpers/localization-helper'

import { GRID_SERVICE_NAME, GridService } from '../grid'
import { SYSTEM_SERVICE_NAME, SystemService } from '../system'
import { ALARM_GROUP_SERVICE_NAME, AlarmGroupService } from "./alarm-group.service"
import { OperatorService } from '../operator';
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session';


//#region Public Types

export const ALARM_GROUP_OPERATORS_SERVICE_NAME = 'AlarmGroupOperatorsService'
export const ALARM_GROUP_OPERATORS_SERVICE_PROVIDER_NAME = 'AlarmGroupOperatorsServiceProvider'

//#endregion


export class AlarmGroupOperatorService {

    //#region Costs

    public static get LOG_PREFIX(): string { return '[SIMAX.Module.AlarmGroup.Operators]' }

    //#endregion

    //#region Ctor

    constructor(
        private gridService: GridService,
        private alarmGroupService: AlarmGroupService,
        private systemService: SystemService,
        private userSession: UserSessionService
    ) { }

    //#endregion


    //#region Save

    public saveOperatorsGridEditResult(alarmGroup: OpAlarmGroup, grid: any[]): JQueryPromise<OpAlarmGroup> {
        const addedOperators: OpOperator[] = []
        const removedOperators: OpOperator[] = []

        _.forEach(grid, (gridItem: any) => {
            if (gridItem.isNew) {
                const operatorToAdd: OpOperator = new OpOperator(null)

                operatorToAdd.idOperator = gridItem.id

                addedOperators.push(operatorToAdd)
            }

            if (gridItem.isRemoved) {
                const operatorToRemove: OpOperator = new OpOperator(null)

                operatorToRemove.idOperator = gridItem.id

                removedOperators.push(operatorToRemove)
            }
        })

        return this.saveOperatorsToAlarmGroup(alarmGroup, addedOperators, removedOperators)
    }

    private saveOperatorsToAlarmGroup(alarmGroup: OpAlarmGroup, addedOperators: OpOperator[], removedOperators: OpOperator[]): JQueryPromise<OpAlarmGroup> {
        const alarmGroupToSave: OpAlarmGroup = new OpAlarmGroup(alarmGroup)

        alarmGroupToSave.opState = Enums.OpChangeState.Modified
        alarmGroupToSave.currentAlarmGroupOperators = []

        _.forEach(addedOperators, (addedOperator: OpOperator) => {
            const clonedOperator: OpOperator = addedOperator.clone(true, true, true, true)
            clonedOperator.opState = Enums.OpChangeState.New

            const operatorExists: boolean = alarmGroup.currentAlarmGroupOperators.some(alarmGroupOperator => alarmGroupOperator.idOperator === clonedOperator.idOperator)

            if (!operatorExists) {
                const currentAlarmGroupOperator: OpAlarmGroupOperator = this.createCurrentAlarmGroupOperator(alarmGroup, clonedOperator)

                alarmGroupToSave.currentAlarmGroupOperators.push(currentAlarmGroupOperator)
            }
        })

        _.forEach(removedOperators, (removedOperator: OpOperator) => {
            const clonedOperator: OpOperator = removedOperator.clone(true, true, true, true)
            clonedOperator.opState = Enums.OpChangeState.Delete

            const currentAlarmGroupOperator: OpAlarmGroupOperator = this.createCurrentAlarmGroupOperator(alarmGroup, clonedOperator)

            alarmGroupToSave.currentAlarmGroupOperators.push(currentAlarmGroupOperator)
        })

        const removedOperatorIds: number[] = removedOperators.map((removedOperator: OpOperator) => removedOperator.idOperator)

        alarmGroupToSave.currentAlarmGroupOperators
            .filter((currentAlarmGroupOperators: OpAlarmGroupOperator) => !_.include([...removedOperatorIds], currentAlarmGroupOperators.idOperator))
            .forEach((loadedOperators: OpAlarmGroupOperator) => {

                const clonedTechnicalPermission: OpAlarmGroupOperator = loadedOperators.clone(true, true, true, true)

                clonedTechnicalPermission.opState = Enums.OpChangeState.Loaded

                alarmGroupToSave.currentAlarmGroupOperators.push(clonedTechnicalPermission)
            })

        if (_.size(addedOperators) > 0 || _.size(removedOperators) > 0) {
            return this.alarmGroupService.saveAlarmGroup(alarmGroupToSave)
        }

        return $.Deferred().resolve(alarmGroup).promise()
    }

    private createCurrentAlarmGroupOperator(alarmGroup: OpAlarmGroup, operator: OpOperator): OpAlarmGroupOperator {
        const currentAlarmGroupOperator: OpAlarmGroupOperator = new OpAlarmGroupOperator(null)

        currentAlarmGroupOperator.idAlarmGroup = alarmGroup.idAlarmGroup
        currentAlarmGroupOperator.idOperator = operator.idOperator
        currentAlarmGroupOperator.idDataType = null
        currentAlarmGroupOperator.alarmGroup = null
        currentAlarmGroupOperator.operator = operator
        currentAlarmGroupOperator.dataType = null
        currentAlarmGroupOperator.opState = operator.opState

        return currentAlarmGroupOperator
    }

    //#endregion

    //#region Options

    public getOperatorsGridColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService.getPopupColumnModelByReferenceType(Enums.ReferenceType.IdOperator)
    }

    public getAlarmGroupOperatorsGridColumn(): ColumnModel[] {
        const nameColumn: ColumnModel = new ColumnModel()

        nameColumn.idName = 'name'
        nameColumn.name = 'Name'
        nameColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operator)

        return [nameColumn]
    }

    public getOperatorGridEditObjectsFromAlarmGroup(alarmGroup: OpAlarmGroup): any {
        return _.map(alarmGroup.currentAlarmGroupOperators, (alarmGroupOperator: OpAlarmGroupOperator) => {
            const gridObject: any = this.gridService.gridObjectFromIOpObject(alarmGroupOperator.operator)

            gridObject.id = alarmGroupOperator.idOperator

            return gridObject
        })
    }

    public openOperatorDetails(idOperator: number, pageOperatorIds: number[]): void {
        this.systemService.openDetails({
            moduleName: Enums.SimaxModuleName.Operator,
            referenceObjectId: idOperator,
            pageItemsIds: pageOperatorIds
        })
    }

    //#endregion
}

export class AlarmGroupOperatorServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        GRID_SERVICE_NAME,
        ALARM_GROUP_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        function (gridService: GridService, alarmGroupService: AlarmGroupService, systemService: SystemService, userSession: UserSessionService) {
            return new AlarmGroupOperatorService(gridService, alarmGroupService, systemService, userSession)
        }]

    //#endregion
} 